/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const AuthAuthPermissions = {
    PROJECT_CREATION: "PROJECT_CREATION",
    DATA_UPLOAD: "DATA_UPLOAD",
    DATA_LABELING: "DATA_LABELING",
    LABELING_REVIEW: "LABELING_REVIEW",
    MODEL_CREATION: "MODEL_CREATION",
    INFERENCE: "INFERENCE",
    SYSTEM_MANAGEMENT: "SYSTEM_MANAGEMENT",
    EDGE: "EDGE",
    COMMISSIONED_INDURION_AGENT: "COMMISSIONED_INDURION_AGENT",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = async ({ secure, path, type, query, format, body, ...params }) => {
            const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = format || this.format || undefined;
            if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
                body = this.createFormData(body);
            }
            if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
                body = qs.stringify(body);
            }
            if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
                body = JSON.stringify(body);
            }
            return this.instance.request({
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
                },
                params: query,
                responseType: responseFormat,
                data: body,
                url: path,
            });
        };
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
}
/**
 * @title RVAI Auth Service
 * @version 0.1.0
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.wellKnown = {
            /**
             * @description List the trusted public keys used to verify platform-signed tokens.
             *
             * @tags key sets
             * @name Jwks
             * @summary Jwks
             * @request GET:/.well-known/jwks.json
             * @secure
             */
            jwks: (params = {}) => this.request({
                path: `/.well-known/jwks.json`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.license = {
            /**
             * No description
             *
             * @tags license
             * @name GetLicense
             * @summary Get License
             * @request GET:/license
             * @secure
             */
            getLicense: (params = {}) => this.request({
                path: `/license`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.livez = {
            /**
             * @description Get application heartbeat.
             *
             * @tags monitor
             * @name GetHeartbeat
             * @summary Get Heartbeat
             * @request GET:/livez
             * @secure
             */
            getHeartbeat: (params = {}) => this.request({
                path: `/livez`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.login = {
            /**
             * No description
             *
             * @tags authentication
             * @name Login
             * @summary Login
             * @request POST:/login
             * @secure
             */
            login: (data, params = {}) => this.request({
                path: `/login`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
        };
        this.logout = {
            /**
             * No description
             *
             * @tags authentication
             * @name Logout
             * @summary Logout
             * @request POST:/logout
             * @secure
             */
            logout: (params = {}) => this.request({
                path: `/logout`,
                method: "POST",
                secure: true,
                ...params,
            }),
        };
        this.m2M = {
            /**
             * No description
             *
             * @tags authentication
             * @name Oauth2Login
             * @summary Oauth2 Login
             * @request POST:/m2m/login
             * @secure
             */
            oauth2Login: (data, params = {}) => this.request({
                path: `/m2m/login`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.UrlEncoded,
                format: "json",
                ...params,
            }),
            /**
             * No description
             *
             * @tags authentication
             * @name Oauth2Refresh
             * @summary Oauth2 Refresh
             * @request POST:/m2m/refresh
             * @secure
             */
            oauth2Refresh: (data, params = {}) => this.request({
                path: `/m2m/refresh`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.UrlEncoded,
                format: "json",
                ...params,
            }),
        };
        this.permissions = {
            /**
             * @description List all permissions. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags roles
             * @name ListPermissions
             * @summary List Permissions
             * @request GET:/permissions
             * @secure
             */
            listPermissions: (params = {}) => this.request({
                path: `/permissions`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.prometheus = {
            /**
             * No description
             *
             * @tags monitor
             * @name GetPrometheusMetrics
             * @summary Get Prometheus Metrics
             * @request GET:/prometheus
             * @secure
             */
            getPrometheusMetrics: (params = {}) => this.request({
                path: `/prometheus`,
                method: "GET",
                secure: true,
                ...params,
            }),
        };
        this.roles = {
            /**
             * @description List all roles. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags roles
             * @name ListRoles
             * @summary List Roles
             * @request GET:/roles
             * @secure
             */
            listRoles: (query, params = {}) => this.request({
                path: `/roles`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a role. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags roles
             * @name CreateRole
             * @summary Create Role
             * @request POST:/roles
             * @secure
             */
            createRole: (data, params = {}) => this.request({
                path: `/roles`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List role fields. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags roles
             * @name ListRoleFields
             * @summary List Role Fields
             * @request GET:/roles/fields
             * @secure
             */
            listRoleFields: (params = {}) => this.request({
                path: `/roles/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a role. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags roles
             * @name DeleteRole
             * @summary Delete Role
             * @request DELETE:/roles/{role_id}
             * @secure
             */
            deleteRole: (roleId, params = {}) => this.request({
                path: `/roles/${roleId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a role. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags roles
             * @name GetRole
             * @summary Get Role
             * @request GET:/roles/{role_id}
             * @secure
             */
            getRole: (roleId, params = {}) => this.request({
                path: `/roles/${roleId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update a role. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags roles
             * @name UpdateRolePermissions
             * @summary Update Role Permissions
             * @request PATCH:/roles/{role_id}
             * @secure
             */
            updateRolePermissions: (roleId, data, params = {}) => this.request({
                path: `/roles/${roleId}`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
        };
        this.users = {
            /**
             * @description List all users. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags users
             * @name ListUsers
             * @summary List Users
             * @request GET:/users
             * @secure
             */
            listUsers: (query, params = {}) => this.request({
                path: `/users`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a user. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags users
             * @name CreateUser
             * @summary Create User
             * @request POST:/users
             * @secure
             */
            createUser: (data, params = {}) => this.request({
                path: `/users`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Activate a user based on an invitation token.
             *
             * @tags users
             * @name ActivateUser
             * @summary Activate User
             * @request POST:/users/activate
             * @secure
             */
            activateUser: (data, params = {}) => this.request({
                path: `/users/activate`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * @description List all users with basic fields (id, firstName, lastName, email). **Accepted permissions:** * DATA_UPLOAD * SYSTEM_MANAGEMENT
             *
             * @tags users
             * @name ListBasicUsers
             * @summary List Basic Users
             * @request GET:/users/basic
             * @secure
             */
            listBasicUsers: (query, params = {}) => this.request({
                path: `/users/basic`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a user with basic fields (id, firstName, lastName, email). **Accepted permissions:** * DATA_UPLOAD * SYSTEM_MANAGEMENT
             *
             * @tags users
             * @name GetBasicUser
             * @summary Get Basic User
             * @request GET:/users/basic/{user_id}
             * @secure
             */
            getBasicUser: (userId, params = {}) => this.request({
                path: `/users/basic/${userId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get current user.
             *
             * @tags users
             * @name GetCurrentUser
             * @summary Get Current User
             * @request GET:/users/current
             * @secure
             */
            getCurrentUser: (params = {}) => this.request({
                path: `/users/current`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Accept terms and conditions.
             *
             * @tags users
             * @name AcceptTermsOfService
             * @summary Accept Terms Of Service
             * @request POST:/users/current/accept-tos
             * @secure
             */
            acceptTermsOfService: (params = {}) => this.request({
                path: `/users/current/accept-tos`,
                method: "POST",
                secure: true,
                ...params,
            }),
            /**
             * @description Update password.
             *
             * @tags users
             * @name ChangePassword
             * @summary Change Password
             * @request PUT:/users/current/password
             * @secure
             */
            changePassword: (data, params = {}) => this.request({
                path: `/users/current/password`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * @description List user fields. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags users
             * @name ListUserFields
             * @summary List User Fields
             * @request GET:/users/fields
             * @secure
             */
            listUserFields: (params = {}) => this.request({
                path: `/users/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get user information based on an invitation token
             *
             * @tags users
             * @name GetInvitationTokenInfo
             * @summary Get Invitation Token Info
             * @request POST:/users/invitation-token-info
             * @secure
             */
            getInvitationTokenInfo: (data, params = {}) => this.request({
                path: `/users/invitation-token-info`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Invite a user. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags users
             * @name InviteUser
             * @summary Invite User
             * @request POST:/users/invite
             * @secure
             */
            inviteUser: (data, params = {}) => this.request({
                path: `/users/invite`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Request a password reset.
             *
             * @tags users
             * @name RequestPasswordReset
             * @summary Request Password Reset
             * @request POST:/users/password-reset
             * @secure
             */
            requestPasswordReset: (data, params = {}) => this.request({
                path: `/users/password-reset`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * @description Delete a user. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags users
             * @name DeleteUser
             * @summary Delete User
             * @request DELETE:/users/{user_id}
             * @secure
             */
            deleteUser: (userId, params = {}) => this.request({
                path: `/users/${userId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a user. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags users
             * @name GetUser
             * @summary Get User
             * @request GET:/users/{user_id}
             * @secure
             */
            getUser: (userId, params = {}) => this.request({
                path: `/users/${userId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Generate new invite token for user. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags users
             * @name RegenerateInviteToken
             * @summary Regenerate Invite Token
             * @request POST:/users/{user_id}/regenerate-invite-token
             * @secure
             */
            regenerateInviteToken: (userId, params = {}) => this.request({
                path: `/users/${userId}/regenerate-invite-token`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update the role of user. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags users
             * @name UpdateUserRole
             * @summary Update User Role
             * @request PATCH:/users/{user_id}/role
             * @secure
             */
            updateUserRole: (userId, data, params = {}) => this.request({
                path: `/users/${userId}/role`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
        };
    }
}
//# sourceMappingURL=data:application/json;base64,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